<div
*ngIf="checkboxSelectedNotifications.length > 0; else notificationDetails"
class="mxn-Notify-Mselected">
  <div>
    <img src="/assets/selected-notifications.svg" alt="">
  </div>
<h3 *ngIf="!selectAllNotificationsInbox">{{checkboxSelectedNotifications.length}} {{ checkboxSelectedNotifications.length === 1 ? 'Notification' : 'Notifications' }} Selected</h3>
<h3 *ngIf="selectAllNotificationsInbox">All Notifications Selected</h3>
<div class="mxn-Notify-selectAll">
  <span (click)="selectAllNotificationsOnPage()">Select notifications on this page</span><br>
  <span (click)="selectAllNotificationsInInbox()">Select all notifications in your list</span>
</div>
<div class="mxn-Notify-selectedAct">
  <div class="mxn-Notify-selectedStat">
    <div class="mb-4">Select an action you’d like to perform</div>
    <div class="flex justify-content-between mb-3">
      <div class="flex flex-column gap-3">
        <button
          [ngClass]="{
            notstarted: notification.statusBadge === 'not-started'
          }"
          (click)="updateNotificationsStatus('not-started')"
          (keydown)="updateNotificationsStatus('not-started')">
          <span class="mxn-sortby-icon"
            ><img src="/assets/hovered.svg" alt="Not Started"/></span
          >{{notStarted}}
        </button>
        <button
          (click)="makeNotificationsReadUnread('true')"
          (keydown)="makeNotificationsReadUnread('true')">
            <img src="/assets/notify-read.svg" alt="Mark as read">
            {{markAsRead}}
        </button>
      </div>
      <div class="flex flex-column gap-3">
        <button href=""
          [ngClass]="{
            inprogress: notification.statusBadge === 'in-progress'
          }"
          (click)="updateNotificationsStatus('in-progress')"
          (keydown)="updateNotificationsStatus('in-progress')"
          >
            <img src="/assets/inprogress.svg" alt="inprogress">
            {{inProgress}}
        </button>
        <button
          (click)="makeNotificationsReadUnread('false')"
          (keydown)="makeNotificationsReadUnread('false')"
    >
            <img src="/assets/notify-unread.svg" alt="Mark as unread">
            {{markAsUnread}}
        </button>
      </div>
      <div class="flex flex-column gap-3">
        <button
          [ngClass]="{
            discharge: notification.statusBadge === 'completed'
          }"
          (click)="updateNotificationsStatus('completed')"
          (keydown)="updateNotificationsStatus('completed')"
          >
            <img src="/assets/check.svg" alt="Completed">
            {{completed}}
        </button>
        <button
          (click)="removeNotifications()"
          (keydown)="removeNotifications()"
    >
            <img src="/assets/trash.svg" alt="Remove">
            {{remove}}
        </button>  
      </div>
    </div>
  </div>
  <span class="mxn-selectedClose-btn"
  (click)="clearMultiSelectedNotifications()"
  (keydown)="clearMultiSelectedNotifications()">
    <img src="/assets/close-icon.svg" alt="Cancel">
    {{cancel}}
  </span>
</div>
</div>

<ng-template #notificationDetails>
  <div
  *ngIf="!loading && !isEmpty && !showDefaultPage; else loadingBlock"
  class="bg-white w-full border-1 border-round border-gray-300"
>
  <div
    [ngClass]="{
      'mxn-notify-detailHeader': true,
      flex: true,
      'justify-content-between': true,
      'align-items-center': true,
      'mxn-notify-detail-header-left-border-completed':
        notification.statusBadge === 'completed',
      'mxn-notify-detail-header-left-border-inprogress':
        notification.statusBadge === 'in-progress',
      'mxn-notify-detail-header-left-border-notstarted':
        notification.statusBadge === 'not-started'
    }"
  >
    <div class="flex justify-content-between align-items-center gap-2">
      <div class="mxn-notify-pImg">
        <img
          [src]="
            notification?.gender === 'F'
              ? '/assets/profile-placeholder-female.svg'
              : '/assets/profile-placeholder.svg'
          "
          alt="profile"
        />
      </div>
      <div class="mxn-notify-pname">{{ notification.patientName }}</div>
      <div class="mxn-notify-extInfo">
        ({{ notification.age }}) {{ notification.gender }}
      </div>
    </div>
    <div
      class="mxn-overlay mxn-notify-statusBadge"
      [ngClass]="{
        discharge: notification.statusBadge === 'completed',
        inprogress: notification.statusBadge === 'not-started',
        notstarted: notification.statusBadge === 'in-progress'
      }"
    >
      <img
        [src]="statusBadgeIconMap.get(notification.statusBadge)"
        alt="Badge"
      />
      {{ notification.statusBadge | keyFormatter }}
      <div class="mxn-overlay-ddm">
        <div class="mxn-overlay-items">
          <ul>
            <li
              [ngClass]="{
                notstarted: notification.statusBadge === 'not-started'
              }"
              (click)="onStatusChange(notification.id, 'not-started')"
              (keydown)="onStatusChange(notification.id, 'not-started')"
            >
              <span class="mxn-sortby-icon"
                ><img src="/assets/hovered.svg" alt="Not Started" /></span
              >{{notStarted}}
            </li>

            <li
              [ngClass]="{
                inprogress: notification.statusBadge === 'in-progress'
              }"
              (click)="onStatusChange(notification.id, 'in-progress')"
              (keydown)="onStatusChange(notification.id, 'in-progress')"
            >
              <span class="mxn-sortby-icon"
                ><img src="/assets/inprogress.svg" alt="In Progress" /></span
              >{{inProgress}}
            </li>

            <li
              [ngClass]="{
                discharge: notification.statusBadge === 'completed'
              }"
              (click)="onStatusChange(notification.id, 'completed')"
              (keydown)="onStatusChange(notification.id, 'completed')"
            >
              <span class="mxn-sortby-icon"
                ><img src="/assets/check.svg" alt="Completed" /></span
              >{{completed}}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <mxn-detail-panel [contentTemplate]="demographicsDetail"></mxn-detail-panel>
  <ng-template #demographicsDetail>
    <mxn-detail-info [details]="notification.demographics"></mxn-detail-info>
  </ng-template>

  <div class="mxn-detail-panel">
    <h3 class="mxn-panel-heading">Organization Panels</h3>
    <div class="mxn-inner-panel">
      <div class="mxn-detail-table-wraper flex justify-content-between gap-4">
        <div class="col-12 flex flex-column gap-2 py-0">
          <ul class="pl-2 m-0">
            <li
              *ngFor="let panel of notification.organisationPanels"
              class="mxn-td-info py-1"
            >
              {{ panel.panelName }}
              <span class="mxn-td-label font-normal">MRN:</span>
              {{ panel.mrn }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <ng-container
    *ngIf="
      notification.eventType === 'COVID' &&
      notification?.laboratoryResults &&
      notification?.laboratoryResults?.length > 0
    "
  >
    <mxn-detail-panel
      heading="Laboratory Result"
      [contentTemplate]="laboratoryTable"
      class="max-nobordered-panel"
    ></mxn-detail-panel>
  </ng-container>

  <ng-template #laboratoryTable>
    <mxn-table
      [columns]="laboratoryColumns"
      [data]="notification.laboratoryResults"
      [headerClasses]="labHeaderClasses"
      [bodyClasses]="labBodyClasses"
      [nestedColumns]="laboratoryNestedColumns"
      [nestedHeaderClasses]="nestedLabHeaderClasses"
      [nestedBodyClasses]="nestedLabBodyClasses"
    >
    </mxn-table>
  </ng-template>

  <div class="mxn-detail-panel" *ngIf="notification.eventType !== 'COVID'">
    <h3 class="mxn-panel-heading">Encounter</h3>
    <div class="mxn-inner-panel p-0">
      <div class="p-3">
        <mxn-detail-info [details]="notification.encounter"></mxn-detail-info>
      </div>
      <div
        *ngIf="notification.conditions && notification.conditions.length > 0"
      >
        <h3 class="mxn-panel-heading border-top-1 border-gray-300 pt-3 pl-3">
          Diagnosis Details
        </h3>
        <div class="max-fulltable diagnosis_detailsTbl">
          <mxn-table
            [columns]="diagnosisColumns"
            [data]="notification.conditions"
            [headerClasses]="diagnosisHeaderClasses"
            [bodyClasses]="diagnosisBodyClasses"
          >
          </mxn-table>
        </div>
      </div>
    </div>
  </div>

  <div class="mxn-detail-panel" #commentsSection>
    <h3 class="mxn-panel-heading">Comments</h3>
    <div *ngIf="!commentLoading">
      <div class="mxn-inner-panel p-3 pr-0 mb-3">
      <div class="mxn-detail-table-wraper">
        <mxn-comment-card
          *ngFor="let comment of notification.comments"
          [comment]="comment"
          (onClickEditComment)="onEditComment(comment)"
          (onClickDeleteComment)="onDeleteComment(comment)"
          [notificationId]="notification?.id"
          [startedEditing]="
            editingCommentId !== '' && comment?.id !== editingCommentId
          "
          [isEditable]="comment.isEditable"
          (toggleEditComment)="toggleEditComment(comment)"
          (refreshNotificationDetail)="getNotificationDetails()"
        ></mxn-comment-card>

        <div class="pr-3">
          <div class="mxn-notify-newcomment mt-3">
            <p-inputGroup class="">
              <input
                type="text"
                class="pInputText"
                placeholder="Type comment here...."
                [(ngModel)]="newComment"
              />
              <button
                type="button"
                class="pButton btn-sm"
                (click)="handleAddComment()"
                [disabled]="isSavingNewComment"
              >
                Add Comment
              </button>
            </p-inputGroup>
          </div>
        </div>
        <div class="flex gap-2">
          <div class="mt-2 text-sm">
            <p-radioButton
              [(ngModel)]="privateComment"
              inputId="CommentPrivacy1"
              name="CommentPrivacy"
              [value]="true"
              ></p-radioButton>
            <label for="CommentPrivacy1" class="ml-1 max-ppc-label"> <span>Private</span></label>
          </div>
          <div class="mt-2 text-sm">
            <p-radioButton
              [(ngModel)]="privateComment"
              inputId="CommentPrivacy2"
              name="CommentPrivacy"
              [value]="false"
              ></p-radioButton>
            <label for="CommentPrivacy2" class="ml-1 max-ppc-label"> <span>Public</span></label>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-auto comments-pagination">
      <mxn-pagination
        [totalItems]="totalComments"
        [rowsPerPage]="commentsPerPage"
        [currentPage]="currentCommentPage"
        (pageChange)="onCommentsPageChange($event)"
        [rowsOptions]="[
          { label: '10', value: 10 },
          { label: '20', value: 20 },
          { label: '30', value: 30 }
          ]"
          [entity]="'Comments'"
          [showExtraDetails]="true"
      ></mxn-pagination>
    </div>
    </div>
    <div class="w-full flex justify-content-center align-content-center">
      <div *ngIf="commentLoading">
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>
    </div>
  </div>

  <div class="mxn-detail-panel">
    <h3 class="mxn-panel-heading">Notification Audit</h3>
    <mxn-table *ngIf="notification?.auditLogs && notification?.auditLogs?.length > 0 && !auditLogLoading"
      [columns]="demographicsColumns"
      [data]="notification.auditLogs"
      [headerClasses]="demographicsHeaderClasses"
      [bodyClasses]="demographicsBodyClasses"
    >
    </mxn-table>

    <div class="flex-auto comments-pagination mt-3">
      <div *ngIf="!auditLogLoading">
      <mxn-pagination
        [totalItems]="totalAuditLogs"
        [rowsPerPage]="auditLogsPerPage"
        [currentPage]="currentAuditLogPage"
        (pageChange)="onAuditLogPageChange($event)"
        [rowsOptions]="[
          { label: '10', value: 10 },
          { label: '20', value: 20 },
          { label: '30', value: 30 }
          ]"
          [entity]="'Audit logs'"
          [showExtraDetails]="true"
      ></mxn-pagination>
      </div>
    </div>

    <div class="w-full flex justify-content-center align-content-center">
      <div *ngIf="auditLogLoading">
        <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
      </div>
    </div>
  </div>
</div>
</ng-template>
<ng-template #loadingBlock>
  <div *ngIf="loading && !isEmpty && !showDefaultPage; else emptyBlock" class="loader">
    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
  </div>
</ng-template>

<ng-template #emptyBlock>
  <div class="mxn-noNotify-select">
    <img
      src="/assets/notificatin-details-icn.svg"
      alt="Select a notification"
    />
    <p>Select a notification from the list to see full details.</p>
  </div>
</ng-template>

<p-dialog
  [modal]="true"
  [(visible)]="visible"
  styleClass="max-confirmation-dialog"
>
  <div class="flex gap-3 px-4">
    <div class="mxn-popup-icon">
      <div class="mxn-warning">
        <img src="assets/ph_warning-light.svg" alt="warning-light" />
      </div>
    </div>
    <div class="flex-1">
      <h3 class="m-0 mb-2">Alert</h3>
      <p class="m-0">Are you sure you want to delete this comment?</p>
    </div>
  </div>
  <div class="flex justify-content-end gap-2 max-dialog-footer">
    <p-button
      label="Cancel"
      severity="secondary"
      (onClick)="visible = false"
      class="max-dialog-cancel-btn"
    />
    <p-button
      label="Confirm"
      (onClick)="visible = false"
      (onClick)="onDeleteCommentConfirm()"
      class="max-dialog-Confirm-btn"
    />
  </div>
</p-dialog>
<p-dialog
  [modal]="true"
  [(visible)]="removeNotificationModal"
  styleClass="max-confirmation-dialog"
>
  <div class="flex gap-3 px-4">
    <div class="mxn-popup-icon">
      <div class="mxn-warning">
        <img src="assets/ph_warning-light.svg" alt="warning-light" />
      </div>
    </div>
    <div class="flex-1">
      <h3 class="m-0 mb-2">{{alert}}</h3>
      <p class="m-0">{{removeNotificationsModalText}}</p>
    </div>
  </div>
  <div class="flex justify-content-end gap-2 max-dialog-footer">
    <p-button
      label="Cancel"
      severity="secondary"
      (onClick)="removeNotificationModal = false"
      class="max-dialog-cancel-btn"
    />
    <p-button
      label="Confirm"
      (onClick)="removeNotificationModal = false"
      (onClick)="onRemoveNotificationsConfirm()"
      class="max-dialog-Confirm-btn"
    />
  </div>
</p-dialog>
